<div (click)="closeModalAndEmptyCart()"></div>

@if (offers) {
  <div class="cart-modal" role="dialog" tabindex="-1" aria-modal="true" aria-label="Cart">
    <div class="cart-modal-header">
      <button class="cart-close" type="button" (click)="closeModalAndEmptyCart()" aria-label="Close cart">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="cart-modal-body">
      <div class="cart-greeting">
        Thank you for your upgrade request for an additional
        <span>{{ calculateTotalPrice(offers) | currency : 'USD' }}</span>, plus tax.
        This fee will be added to your current room rate.
      </div>

      <div class="cart-table-wrapper">
        <app-shopping-cart-table
          [offers]="offers"
          [offerAliasId]="offerAliasId"
          [propertyId]="propertyId"
          (remove)="removeOfferFromCart({ offer: $event.offer, aliasId: $event.aliasId })">
        </app-shopping-cart-table>
      </div>

      <div class="cart-section-title">Here's what happens next:</div>
      <p><b>Review:</b> Your upgrade request will be reviewed by the hotel prior to arrival and is subject to availability.</p>
      <p><b>Notification:</b> You will receive an email confirming whether your request has been approved or declined.</p>
      <p>
        <b>Policy:</b> If approved, the upgrade fee (plus applicable taxes) will be added to your reservation and charged by the hotel. Upgrade charges may be non-refundable according to the hotel’s policies. Upgrades are based on availability and at the hotel’s discretion.
      </p>

      <p style="margin-top: 12px">We appreciate your stay with us and look forward to making your visit special.</p>
    </div>

    <div class="cart-modal-footer">
      <div class="cart-footer-left">
        <label class="cart-consent">
          <input type="checkbox" [checked]="acknowledgment" (change)="toggleAcknowledgment()" />
          <span class="cart-consent-label">I understand and agree to the upgrade terms.</span>
        </label>

        <div class="cart-footer-note">
          Upgrade offers are provided by Prestay.luxe on behalf of {{ sharedService.propertyName | titlecase }}.
          Review our
          <a class="text-link" href="" (click)="$event.preventDefault(); navigatePrivacy()">Privacy Policy</a>
          and
          <a class="text-link" href="" (click)="$event.preventDefault(); navigateTerms()">Terms of Service</a>.
        </div>
      </div>

      <button
        type="button"
        class="btn-request"
        [class.enabled]="acknowledgment"
        [disabled]="!acknowledgment"
        (click)="acceptOffer()">
        <span class="material-icons">upgrade</span>
        Request Upgrade
      </button>
    </div>
  </div>
}
